import React, { useState } from 'react';
import moment from "moment";
import { Trans } from 'react-i18next';

import { useLazyQuery, useMutation } from '@apollo/client';
import { CREATE_BOOKING } from '../../../../GraphQL/Mutations/bookings';
import { GET_VEHICLE_BY_SOURCE_ID } from '../../../../GraphQL/Queries/vehicles';

import { constants } from '../../../../Helpers/Constants';
import { reverseReceiveTime } from '../../../../Helpers/ReceiveTimeInArray';

export const EUBookingFormButtons = ({ toggleRequest, legacyApiCreateBooking, settings, userSession, history }) => {
    const [loadingCreate, setLoadingCreate] = useState(false);

    const [createBookingMutation, { data, loading, error }] = useMutation(CREATE_BOOKING);

    const [getVehicleQuery, { loading: loadingVehicle }] = useLazyQuery(GET_VEHICLE_BY_SOURCE_ID, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
    });

    const parseBookingFormInput = (vehicleId, bookingBody, legacyApiCreatedBooking) => {
        const { booking_type, vehicle_usage, notes, pick_up_person } = bookingBody;
        const { Start_Date, Release_Time, End_Date, Return_Time } = legacyApiCreatedBooking;

        const type = Object.keys(constants.booking_type).find(key => constants.booking_type[key] === booking_type);

        const getIsoFromDateTime = (date, time) => moment(`${date} ${time}`).format('YYYY-MM-DDTHH:mm:ssZ');

        return {
            vehicleId: parseInt(vehicleId),
            type,
            userId: userSession.user.user_id,
            profileId: userSession.user.profile_id,
            releasedTo: pick_up_person,
            scheduledReleasedAt: getIsoFromDateTime(Start_Date, Release_Time),
            scheduledReturnedAt: getIsoFromDateTime(End_Date, Return_Time),
            specialRequestRemark: notes,
            status: 'pending',
            usageType: settings.vehicle_usage_types[vehicle_usage],
        }
    }

    // [not in use due to queue data sync implementation]
    const createBookingGraphQL = (bookingBody, legacyApiCreatedBooking) => {
        const sourceBookingId = legacyApiCreatedBooking.BOOK_ID;

        // TODO: remove this query when we migrate the vehicle list to graphql (we'll have the correct vehicle id)
        getVehicleQuery({ variables: { sourceVehicleId: +bookingBody.vehicle_id } })
            .then((vehicleResponse) => {
                const vehicleId = vehicleResponse?.data.getVehicleBySourceVehicleId.id

                const parsedBookingInput = parseBookingFormInput(vehicleId, bookingBody, legacyApiCreatedBooking);

                const input = {
                    ...parsedBookingInput,
                    sourceBookingId
                }

                createBookingMutation({ variables: { input } }).then((response) => {
                    setLoadingCreate(false);

                    showStatusMsg('Booking created successfully', 'success');
                    history.push("/bookings/pending")
                }).catch((error) => {
                    setLoadingCreate(false);
                    console.error('[createBookingMutation] error: ', error);
                });
            }).catch((error) => {
                setLoadingCreate(false);
                console.error('[getVehicle] error: ', error);
            });
    }

    const createPendingBooking = () => {
        // [not in use due to queue data sync implementation]
        // setLoadingCreate(true);
        return legacyApiCreateBooking(createBookingGraphQL, setLoadingCreate)
    };

    return (
        <div className="booking_bottom border-top">
            <a className="button alert ml-16" onClick={toggleRequest}><Trans>Cancel</Trans></a>
            <button className="button primary ml-16" onClick={createPendingBooking} disabled={loadingCreate}><Trans>Submit Booking</Trans></button>
        </div>
    )
}